import React, { Suspense } from "react";
import {Routes, Route} from "react-router-dom";
import Index from "./Index/Index";
const Rest = React.lazy(() => import('./Rest/Rest'));
import Key from "./Key/Key";
import Stock from "./Stock/Stock";
import SkuMapping from "./SkuMapping/SkuMapping";

export default function Api() {
    return (
        <div className={"py-4"}>
            <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/index" element={<Index />} />
                <Route path="/rest" element={<Suspense fallback={<div />}><Rest /></Suspense>} />
                <Route path="/key" element={<Key />} />
                <Route path="/stock" element={<Stock />} />
                <Route path="/sku-mapping" element={<SkuMapping />} />
            </Routes>
        </div>
    );
}
